import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {SelectButton} from 'primeng/selectbutton';
import {Textarea} from 'primeng/textarea';
import {Question} from '../../../../../../models/Question';

@Component({
    selector: 'app-wizard-completed',
    imports: [
        ReactiveFormsModule
    ],
    templateUrl: './wizard-completed.component.html',
    styleUrl: './wizard-completed.component.scss'
})
export class WizardCompletedComponent {

    // region Variables

    @Input() question: Question | null = null;
    public questionForm: FormGroup | undefined;

    // endregion

    // Constructor
    constructor() {
    }

    // Init
    ngOnInit() {

        // Create Question Form
        this.questionForm = new FormGroup({
            selectedAnswers: new FormControl('', [Validators.required]),
            notes: new FormControl('')
        });

    }

}
